
import {
  Table,
  TableColumn
} from "element-ui";
import Modal from "@/components/Modal.vue";
import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import {translations} from '@/mixins'
import moment from "moment"

@Component({
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  filters: {
    formatDate(date: string, format: string = 'MMM D YYYY hh:mm A') {
      return moment
        .utc(date, "YYYY-MM-D hh:mm:ss")
        .locale("en-us")
        .local()
        .format(format) || '';
    }      
  },
  mixins: [translations],
})

export default class DeliveryLogPayloadResponseModal extends Vue {
  @Prop() openPayload: boolean = false
  @Prop() response?: Object
  @Prop() payload?: Object

  constructor() {
    super();
  }

  get isOpen(): Boolean {
    return this.openPayload;
  }

  set isOpen(newVal: Boolean) {
    this.$emit("openPayload", newVal);
    if (!newVal) {
    }
  }

  @Watch('openPayload', {deep: true})
  onOpenPayloadChanged(newVal: any) {
    this.isOpen = newVal
  }

  payloadClose() {
    this.$emit('payloadClose', false)
  }
}
